import { Image, Text, TouchableOpacity, View } from 'react-native';
import styles from '../Styles';
import Throb from './Throb';

const ThrobbingButton = (props) => {
  // props include:
  // - tappedButton()
  // - coverStyle
  // - skipIcon
  // - textStyle
  // - buttonText
  // - imagePath
  // - visible

  const pressedButton = () => {
    props.tappedButton();
  };

  const imageIcon = () => {
    if (!props.skipIcon) {
      return (
        <Image source={props.imagePath}
               style={{width: 100, height: 100}} />
      );
    } else {
      return null;
    }
  };

  return (
    <TouchableOpacity onPress={pressedButton} underlayColor="white">
      <View style={props.coverStyle}>
        <Throb>
          <View style={{minHeight: 120, padding: 10, justifyContent: 'center', alignItems: 'center'}}>
            {imageIcon()}
            
            <Text style={styles.contentItemCoverText}>{props.buttonText}</Text>
          </View>
        </Throb>
      </View>
    </TouchableOpacity>
  );
};

export default ThrobbingButton;
